import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
const propTypes = {
  xs: PropTypes.bool,
  sm: PropTypes.bool,
  md: PropTypes.bool,
  lg: PropTypes.bool,
  xl: PropTypes.bool
};
const Visible = createComponent({
  displayName: 'Visible',
  root: 'div',
  propTypes,
  propConfig: {
    classNames(props) {
      const classNameSet = new Set();
      const {
        xs,
        sm,
        md,
        lg,
        xl
      } = props;
      if (xs) classNameSet.add('swan-visible-xs');
      if (sm) classNameSet.add('swan-visible-sm');
      if (md) classNameSet.add('swan-visible-md');
      if (lg) classNameSet.add('swan-visible-lg');
      if (xl) classNameSet.add('swan-visible-xl');
      return classNameSet;
    }
  }
});
export { Visible };